import { GlobalFilterType } from '@app/core/models/common.models';

export class GlobalFilterNotFound {
  static type = '[Global Filters] 404';

  constructor(readonly data?: Partial<GlobalFilterType>) {}
}

export class DefaultGlobalFilters {
  static type = '[Global Filters] default filters';

  constructor(readonly options?: { showAllAccounts?: boolean }) {}
}

export class GlobalFilterSelected {
  static type = '[Global Filters] Filter selected';

  constructor(
    readonly queryParam: string,
    isDestination?: boolean,
  ) {}
}

export class GlobalFilterRemoved {
  static type = '[Global Filters] Filter removed';

  constructor(
    readonly queryParam: string,
    isDestination?: boolean,
  ) {}
}
